import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import LeftbarProfile from './Leftbar';
import PostFirst from './PostFirst';
import PostSecond from './PostSecond';
import PostThird from './PostThird';
import UserProfile from './UserProfile';

const TourMain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Tour' parent='Bonus Ui' title='Tour' />
      <div className='user-profile'>
        <Row>
          <UserProfile />
          <LeftbarProfile />
          <Col xl='8' lg='12' md='7' className='box-col-70'>
            <Row>
              <PostFirst />
              <PostSecond />
              <PostThird />
            </Row>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default TourMain;
